<template>
    <b-modal
        id="add-slu-course-modal"
        ref="add-slu-course-modal"
        size="lg"
        :title="$t('slu_dashboard.add_courses')"
        modal-class="apprentice-default-modal add-slu-course"
        :ok-title="$t('common.save')"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        @ok="onOk">
        <design-2021-apprentice-data-table
            class="slu-dashboard-courses"
            :items="tableData"
            :fields="courseFields">
            <template #cell(isActive)="data">
                <div class="settings-toggle">
                    <b-form-checkbox
                        v-model="data.item.isActive"
                        :id="`slu-course-${data.item.id}`"
                        :value="1"
                        size="5"
                        :unchecked-value="0"
                        :disabled="data.item.disabled"
                        switch>
                    </b-form-checkbox>
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-add-slu-course-modal-component',
    props: ['coursesIn', 'sluCoursesIn'],
    data() {
        return {
            sluCourses: this.sluCoursesIn,
            courseFields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'isActive',
                    label: 'active',
                },
            ],
        };
    },
    methods: {
        onOk() {
            let data = this.tableData
                .filter(function (course) {
                    if (!course.isActive) {
                        return false;
                    }
                    return true;
                })
                .map((course) => course.id);

            this.alert.saving();
            this.axios.post(this.routes.sluCourses(), data).then(
                (response) => {
                    this.$emit('updateCourses', response.data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
    computed: {
        tableData() {
            return this.coursesIn.map((course) => {
                return {
                    id: course.id,
                    name: course.name,
                    isActive: this.sluCourses.find((sluCourse) => sluCourse.course_id === course.id) ? 1 : 0,
                };
            });
        },
    },
};
</script>

<style scoped></style>
